/* eslint-disable react/prop-types */
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import CopyButton from '../../../../../partials/content/CopyButton'
import DetailRow from '../../../../../components/DetailRow'
import { formatAddress } from '../utils'
import EmployeeActionToolbar from '../EmployeeActionToolbar'
import { formatDateOnly } from '../../../../../util/date.util'

function UserProperties(props) {
  const {
    employee,
    selectedCustomer,
    onEdit,
    overrideEngageLicensing = false,
    canPerformActions = true,
    setAction,
    setModal,
    openIntegrationModal,
    selectedIntegration,
  } = props

  const intl = useIntl()

  return (
    <>
      <EmployeeActionToolbar
        employee={employee}
        selectedCustomer={selectedCustomer}
        onEdit={onEdit}
        canPerformActions={canPerformActions}
        overrideEngageLicensing={overrideEngageLicensing}
        setAction={setAction}
        setModal={setModal}
        openIntegrationModal={openIntegrationModal}
        selectedIntegration={selectedIntegration}
      />

      <div className="section px-4 py-4">
        {/* Identity Section */}
        <Row className="mb-4">
          <Col sm="12">
            <h6 className="text-bold mb-3" style={{ fontSize: '1rem', color: 'var(--bs-body-color)' }}>
              Identity
            </h6>

            <DetailRow label="Display name" value={employee.display_name} size="sm" />

            <DetailRow label="First name" value={employee.first_name} size="sm" />

            <DetailRow label="Last name" value={employee.last_name} size="sm" />

            <DetailRow label="User type" value={employee.userType} size="sm" />

            <DetailRow
              label="Object ID"
              value={
                employee.employeeIdentifier ? (
                  <div className="d-flex align-items-center" style={{ gap: '0.5rem' }}>
                    <span>{employee.employeeIdentifier}</span>
                    <CopyButton textToCopy={employee.employeeIdentifier} />
                  </div>
                ) : null
              }
              size="sm"
            />
          </Col>
        </Row>

        {/* Contact Information Section */}
        <Row
          className="mb-4"
          style={{ borderTop: '1px solid var(--aug-ui-divider-subtle)', paddingTop: '1.5rem', marginTop: '1.5rem' }}
        >
          <Col sm="12">
            <h6 className="text-bold mb-3" style={{ fontSize: '1rem', color: 'var(--bs-body-color)' }}>
              Contact Information
            </h6>

            <DetailRow label="Address" value={formatAddress(employee)} size="sm" />

            <DetailRow label="Country/Region" value={employee.usageLocation} size="sm" />

            <DetailRow label="Business phone" value={employee.businessPhone || employee.phone} size="sm" />

            <DetailRow label="Mobile phone" value={employee.mobilePhone} size="sm" />

            <DetailRow label="Email" value={employee.email} size="sm" />

            <DetailRow
              label="Alternate email"
              value={employee.otherMails && employee.otherMails.length > 0 ? employee.otherMails.join(', ') : null}
              size="sm"
            />

            <DetailRow label="Fax" value={employee.fax} size="sm" />

            <DetailRow label="Mail nickname" value={employee.mailNickname} size="sm" />
          </Col>
        </Row>

        {/* Job Information Section */}
        <Row
          className="mb-4"
          style={{ borderTop: '1px solid var(--aug-ui-divider-subtle)', paddingTop: '1.5rem', marginTop: '1.5rem' }}
        >
          <Col sm="12">
            <h6 className="text-bold mb-3" style={{ fontSize: '1rem', color: 'var(--bs-body-color)' }}>
              Job Information
            </h6>

            <DetailRow label="Job title" value={employee.job_title} size="sm" />

            <DetailRow label="Company name" value={employee.companyName} size="sm" />

            <DetailRow label="Department" value={employee.department} size="sm" />

            <DetailRow label="Employee ID" value={employee.employeeId} size="sm" />

            <DetailRow label="Employee type" value={employee.employeeType} size="sm" />

            <DetailRow label="Employee hire date" value={formatDateOnly(employee.hireDate, intl)} size="sm" />

            <DetailRow label="Office location" value={employee.officeLocation} size="sm" />

            <DetailRow label="Manager" value={employee.manager?.displayName} size="sm" />
          </Col>
        </Row>

        {/* Settings Section */}
        <Row
          className="mb-4"
          style={{ borderTop: '1px solid var(--aug-ui-divider-subtle)', paddingTop: '1.5rem', marginTop: '1.5rem' }}
        >
          <Col sm="12">
            <h6 className="text-bold mb-3" style={{ fontSize: '1rem', color: 'var(--bs-body-color)' }}>
              Settings
            </h6>

            <DetailRow
              label="Account enabled"
              value={(() => {
                if (employee.isUserSigninEnabled !== undefined) {
                  return employee.isUserSigninEnabled ? 'Yes' : 'No'
                }
                if (employee.enabled !== undefined) {
                  return employee.enabled ? 'Yes' : 'No'
                }
                return null
              })()}
              size="sm"
            />

            <DetailRow label="Usage location" value={employee.usageLocation} size="sm" />
          </Col>
        </Row>
      </div>
    </>
  )
}

export default UserProperties
